import { cn } from "@/libs/base/utils/layout";
import { ButtonHTMLAttributes, forwardRef } from "react";

interface GenrePillProps {
  genre: string;
  active: boolean;
}

export const GenrePill = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement> & GenrePillProps>(
  ({ genre, active, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "relative flex flex-1 select-none items-center justify-center rounded-full px-8 py-1 text-sm font-medium uppercase transition-all duration-500 sm:text-xs",
          active ? "bg-black text-left text-white" : "bg-lightgray-100 text-black hover:bg-lightgray-300",
          className,
        )}
        {...props}
      >
        {genre}
      </button>
    );
  },
);
